module.exports = __webpack_public_path__ + "static/media/manage-credits.bd1a4770.svg";